import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32db62ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "希望業種", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "希望職種", -1))
const _hoisted_9 = { class: "profile_item_value" }
const _hoisted_10 = { class: "profile_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "希望勤務地", -1))
const _hoisted_12 = { class: "profile_item_value" }
const _hoisted_13 = { class: "profile_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "希望年収", -1))
const _hoisted_15 = { class: "profile_item_value" }
const _hoisted_16 = { class: "profile_item_value_text" }
const _hoisted_17 = { class: "profile_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "転職希望時期", -1))
const _hoisted_19 = { class: "profile_item_value" }
const _hoisted_20 = { class: "profile_item_value_text" }
const _hoisted_21 = { class: "profile_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "希望雇用形態", -1))
const _hoisted_23 = { class: "profile_item_value" }
const _hoisted_24 = {
  key: 0,
  class: "profile_item_value_text"
}
const _hoisted_25 = {
  key: 1,
  class: "profile_item_value_text"
}
const _hoisted_26 = { class: "profile_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "ご希望条件の詳細", -1))
const _hoisted_28 = { class: "profile_item_value" }
const _hoisted_29 = { class: "profile_item_value_text" }
const _hoisted_30 = { class: "profile_button_register" }
const _hoisted_31 = { class: "profile_button_modify" }

import { ref, Ref, watch, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';
import { DesiredCondition } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredConfirmView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const desiredCondition: Ref<DesiredCondition> = ref(store.getters['careerSheetDesired/desiredCondition']);
const mstIndsctgFlat = computed(() => store.getters['master/mstIndsctgFlat']);
const mstOcupClassFlat = computed(() => store.getters['master/mstOcupClassFlat']);
const mstListPrefOptions: Ref<{ label: string; value: number }[]> = computed(() => store.getters['master/mstListPrefOptions']);
const mstWishJobChangeDateId: Ref<{ code: number; name: string }[]> = computed(() =>
  store.getters['master/mstWishJobChangeDateId']);

const wishIndsctgNames: Ref<string[]> = computed(() => {
  const res = [];
  if (desiredCondition.value.wishIndsctg1Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg1Id]);
  }
  if (desiredCondition.value.wishIndsctg2Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg2Id]);
  }
  if (desiredCondition.value.wishIndsctg3Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg3Id]);
  }
  if (desiredCondition.value.wishIndsctg4Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg4Id]);
  }
  if (desiredCondition.value.wishIndsctg5Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg5Id]);
  }
  if (desiredCondition.value.wishIndsctg6Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg6Id]);
  }
  return res;
});
const wishOcupctgNames: Ref<string[]> = computed(() => {
  const res: string[] = [];
  if (desiredCondition.value.wishOcupctg1Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg1Id]);
  }
  if (desiredCondition.value.wishOcupctg2Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg2Id]);
  }
  if (desiredCondition.value.wishOcupctg3Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg3Id]);
  }
  if (desiredCondition.value.wishOcupctg4Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg4Id]);
  }
  if (desiredCondition.value.wishOcupctg5Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg5Id]);
  }
  if (desiredCondition.value.wishOcupctg6Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg6Id]);
  }
  return res;
});
const wishWkareaNames: Ref<string[]> = computed(() => {
  const nameArray: string[] = [];
  if (desiredCondition.value.wishWkarea1Id) {
    const wishWkarea1Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea1Id))[0]?.label || '';
    if (wishWkarea1Name) {
      nameArray.push(wishWkarea1Name);
    }
  }
  if (desiredCondition.value.wishWkarea2Id) {
    const wishWkarea2Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea2Id))[0]?.label || '';
    if (wishWkarea2Name) {
      nameArray.push(wishWkarea2Name);
    }
  }
  if (desiredCondition.value.wishWkarea3Id) {
    const wishWkarea3Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea3Id))[0]?.label || '';
    if (wishWkarea3Name) {
      nameArray.push(wishWkarea3Name);
    }
  }
  if (desiredCondition.value.wishWkarea4Id) {
    const wishWkarea4Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea4Id))[0]?.label || '';
    if (wishWkarea4Name) {
      nameArray.push(wishWkarea4Name);
    }
  }
  return nameArray;
});

const formattedAnnualIncome = computed(() => {
  const income = desiredCondition.value.wishAnnualIncomeNum;
  return income ? `${income.toLocaleString()} 万円` : '未設定';
});

const selectedChangeDateValueLabel = computed(() => {
  const id = Number(desiredCondition.value.wishJobChangeDateId);
  const match = mstWishJobChangeDateId.value.find(
    (item) => item.code === id
  );
  return match ? match.name : '';
});

const isLoading = ref(false);

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e41', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e41' });
  }
};

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('careerSheetDesired/putDesiredCondition');
    store.dispatch('toasts/appendTimeToast', { label: '希望条件を更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e40', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n40' });
    }
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: '希望条件の更新に失敗しました', duration: null });
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishIndsctgNames), (wishIndsctgName) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "profile_item_value_text",
            key: wishIndsctgName
          }, _toDisplayString(wishIndsctgName), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishOcupctgNames), (wishOcupctgName) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "profile_item_value_text",
            key: wishOcupctgName
          }, _toDisplayString(wishOcupctgName), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishWkareaNames), (wishWkareaName) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "profile_item_value_text",
            key: wishWkareaName
          }, _toDisplayString(wishWkareaName), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(formattedAnnualIncome)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(selectedChangeDateValueLabel)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        (desiredCondition.value.empTypeFlg1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, "正社員"))
          : _createCommentVNode("", true),
        (desiredCondition.value.empTypeFlg5)
          ? (_openBlock(), _createElementBlock("p", _hoisted_25, "契約社員"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("p", _hoisted_29, _toDisplayString(desiredCondition.value.demand), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(BaseButton, {
        theme: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("この内容で決定する")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(BaseButton, {
        theme: "secondary",
        onClick: transitionPreviousPage
      }, {
        default: _withCtx(() => [
          _createTextVNode("修正する")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})